import { render, staticRenderFns } from "./MFormRadioGroup.vue?vue&type=template&id=f0316604&"
import script from "./MFormRadioGroup.vue?vue&type=script&lang=js&"
export * from "./MFormRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports